/**
 * Format field name to display title
 */
export const formatFieldTitle = (fieldName) => {
    // Handle specific field name mappings
    const fieldMappings = {
        'firstname': 'First Name',
        'lastname': 'Last Name',
        'email': 'Email',
        'phone': 'Phone',
        'address': 'Address',
        'city': 'City',
        'state': 'State',
        'zip': 'Zip',
        'homeowner': 'Home Owner',
        'projecttype': 'Project Type',
        'sidingtype': 'Siding Type',
        'windowcount': 'Window Count',
        'roofmaterial': 'Roof Material',
        'addremovewalls': 'Add Remove Walls',
        'powerbill': 'Power Bill',
        'electricityprovider': 'Electricity Provider',
        'roofshade': 'Roof Shade',
        'creditscore': 'Credit Score',
        'propertytype': 'Property Type',
        'activemilitary': 'Active Military',
        'employmentstatus': 'Employment Status',
        'cashout': 'Cash Out',
        'fhaloan': 'FHA Loan',
        'propertyvalue': 'Property Value',
        'loanamount': 'Loan Amount',
        'propertycondition': 'Property Condition',
        'reasonforselling': 'Reason For Selling',
        'timeframe': 'Timeframe',
        'creditcarddebt': 'Credit Card Debt',
        'dob': 'Age',
        'ltv': 'LTV (0.0-1.0)',
    };

    // Check if there's a direct mapping
    if (fieldMappings[fieldName.toLowerCase()]) {
        return fieldMappings[fieldName.toLowerCase()];
    }

    return fieldName;
}
